//index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getConfig } from './auth/config';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import history from "./components/util/history";

// "Create your business" intent (e.g. from the marketing site → /home?create=1).
// Stash it BEFORE Auth0's redirect round-trip strips the query string;
// sessionStorage survives same-tab navigations, so HomeComponent can reopen the
// onboarding wizard once the user is back and authenticated.
try {
    if (new URLSearchParams(window.location.search).get('create') === '1') {
        sessionStorage.setItem('gs_create_business', '1');
    }
} catch { /* sessionStorage unavailable — fall back to the URL param only */ }


const onRedirectCallback = (appState?: AppState) => {
    history.push(
        appState && appState.returnTo ? appState.returnTo : window.location.pathname
    );
};
const config = getConfig();

const providerConfig = {
    domain: config.domain,
    clientId: config.clientId,
    onRedirectCallback,
    // Persist the session across page reloads (F5) and tab restarts.
    // Without these, every F5 sends the user back through Auth0 consent.
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    authorizationParams: {
        // Include the base path so Auth0 returns to /admin when served behind
        // nginx (PUBLIC_URL=/admin in ngrok mode); '' locally → just the origin.
        redirect_uri: window.location.origin + (process.env.PUBLIC_URL || ''),
        ...(config.audience ? { audience: config.audience } : null),
    }
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <Auth0Provider {...providerConfig}>
        <App />
    </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();